<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2024-01-15 10:34:14
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-15 10:34:17
 * @FilePath: /partner.chaoyongtuan.com/src/views/settings/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <router-view></router-view>
</template>

<script>
export default {
name: "index"
}
</script>

<style scoped>

</style>
